import {ICON} from "../../Icons/Icons";

const template = `
<div class="calling-popup">
  <div class="calling-popup__icon-wrapper">
      <div class="calling-popup__icon-pulse calling-popup__icon-pulse--outer"></div>
      <div class="calling-popup__icon-pulse calling-popup__icon-pulse--middle"></div>
      <div class="calling-popup__icon-pulse calling-popup__icon-pulse--inner"></div>
      <div class="calling-popup__icon">
        ${ICON.CALL}
      </div>
    </div>
    <div class="calling-popup__text">
      <span class="calling-popup__status">Calling</span>
      <span class="calling-popup__name"></span>
    </div>
    <div class="calling-popup__actions">
      <button class="calling-popup__button calling-popup__button--cancel end-call-btn">
        <span>Cancel</span>
      </button>
    </div>
</div>
`

export class CallingDialog {
  constructor() {
    this.template = $(template);
    this.isVisible = false;
    this.setupListeners();
  }

  setupListeners() {
    this.template.find('.calling-popup__button--cancel').on('click', () => {
      this.hide();
      // Trigger event for call cancellation
      $(document).trigger('calling:cancelled');
    });
  }

  show(name) {
    if (this.isVisible) return;

    // Set the name of the person being called
    this.template.find('.calling-popup__name').text(name);

    // Append to body if not already in DOM
    if (!this.template.parent().length) {
      $('body').append(this.template);
    }

    // Show the popup with animation
    this.template.addClass('calling-popup--visible');
    this.isVisible = true;
  }

  hide() {
    this.template.removeClass('calling-popup--visible');
    this.isVisible = false;

    // Remove from DOM after animation completes
    setTimeout(() => {
      if (!this.isVisible) {
        this.template.detach();
      }
    }, 300); // Match this with CSS transition duration
  }
}
